import React from "react";
import { FormattedMessage } from "react-intl";
import { Button } from "reactstrap";
import { ClientDetailsTable } from "./view/ClientDetailsTable";
import { ACL } from '../../../../config/constants';

function ClientDetailsTab(props) {
  const { user, toggleEditMode } = props;

  return (
    <section className="user-detail-section">
      {ACL.CLIENT.USERS.EDIT.hasAccess() && user && user.id && (
        <div className="user-detail-section__header">
          <Button
            color="primary"
            className="btn-warning"
            type="button"
            onClick={() => {
              toggleEditMode( "user", true );
            }}
          >
            <FormattedMessage id="button.edit"/>
          </Button>
        </div>
      )}
      <ClientDetailsTable user={user}/>
    </section>
  );
}

export { ClientDetailsTab };
